/* eslint id-length: "off" */
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowUpRightFromSquare} from "@fortawesome/free-solid-svg-icons";
import {SOURCE_LABELS} from "@/lib/music/parseTracks";

const MDMusicExternalLink = ({className = "", track}) => {
  if (!track.externalUrl) {
    return null;
  }
  return (
    <a className={`is-size-7 mdmusic-external ${className}`.trim()}
       href={track.externalUrl}
       rel="noopener noreferrer"
       target="_blank"
    >
      <span>Listen on {SOURCE_LABELS[track.source]}</span>
      <span className="icon is-small ml-1">
        <FontAwesomeIcon icon={faArrowUpRightFromSquare}/>
      </span>
    </a>
  );
};

MDMusicExternalLink.propTypes = {
  className: PropTypes.string,
  track: PropTypes.shape({
    externalUrl: PropTypes.string,
    source: PropTypes.string.isRequired,
  }).isRequired,
};

export default MDMusicExternalLink;
